import React from 'react'
import './Scss/Header.scss'
//material ui
import MenuIcon from '@material-ui/icons/Menu';
import PhoneIcon from '@material-ui/icons/Phone';

const Header = () => {
    return (
        <header>
            <div className="header-top">
                <div className="float-right">
                    <div className="phone"><PhoneIcon />&nbsp;(917) 680-2883</div>
                    <div className="language ml-4 mr-4"><span ><a href="/Login">Login</a> / <a href="/SignUp">Register</a></span></div>
                </div>
            </div>

            <nav className="navbar navbar-expand-lg navbar-light">
                <a className="navbar-brand" href="/"><img src="/images/logo.png" style={{height:55, width:"auto"}} alt="logo"/></a>       

                <button className="navbar-toggler" type='button' data-toggle="collapse" data-target="#headerNavContent" aria-controls="headerNavContent" aria-expanded="false" aria-label="toggle navigation">
                    <MenuIcon />
                </button>

                <div className="collapse navbar-collapse" id="headerNavContent">
                    <ul className="navbar-nav ml-auto menu">
                        <li className="nav-item"><a className="nav-link" href="/" >Home</a></li>
                        <li className="nav-item"><a className="nav-link" href="/Properties" >Properties</a></li>
                        <li className="nav-item"><a className="nav-link" href="/Agents" >Agents</a></li>
                    </ul>
                </div>
            
            </nav>
        </header>
    )
}

export default Header